import React  from 'react';
import Card from '../../components/Card/card.js';
import './formation.css';

export default function Formation() {

	return (
		<section className="text-formation">
			<div className="container">
				<h1>Nos Formations</h1>
				<section className="formations-grid">
					<Card
						image="/images/bts.png"
						title="Cycle BTS - Brevet de Technicien Supérieur"
						link="/cycles/bts"
						width="550px"
						height="380px"
						imageHeight="330px"
					/>
					<Card
						image="/images/lmd.png"
						title="Cycle LMD - Licence, Master, Doctorat"
						link="/cycles/lmd"
						width="550px"
						height="380px"
						imageHeight="330px"
					/>
				</section>
				<h3>Modalités de Formation</h3>
				<section className="modalites-grid">
					<Card
						image="/images/presentiel.webp"
						title="Formation Présentielle - Cours en campus avec accompagnement personnalisé"
						clickable={false}
						width="350px"
						height="280px"
						imageHeight="190px"
					/>
					<Card
						image="/images/distanciel.jpg"
						title="Formation à Distance - Flexibilité et autonomie d'apprentissage"
						clickable={false}
						width="350px"
						height="280px"
						imageHeight="190px"
					/>
					<Card
						image="/images/continue.jpeg"
						title="Formation Continue - Pour les professionnels en activité"
						clickable={false}
						width="350px"
						height="280px"
						imageHeight="190px"
					/>
				</section>

				<div className="cta-section">
					<h2>Prêt à Commencer ?</h2>
					<p>
						Découvrez le programme qui correspond à vos ambitions et lancez-vous
						dans l'aventure IUSSE.
					</p>
					<div className="cta-buttons">
						<Card
							image="/images/rejoignez-nous.png"
							title="Télécharger la Brochure"
							onClick={() => window.open('/fiche_de_renseignement_iusse.pdf', '_blank')}
							width="300px"
							height="200px"
							imageHeight="150px"
						/>
					</div>
				</div>
			</div>
		</section>
	);
}
